import type { SxProps, Theme } from '@mui/material';

export const container: SxProps<Theme> = {
  padding: '0 24px',
  flexGrow: 1,
  paddingBottom: 40,
};

export const loadingContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '200px',
};

export const errorContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '200px',
  color: 'red',
};

export const errorText: SxProps<Theme> = {
  color: 'red',
};

export const backButtonContainer: SxProps<Theme> = {
  mt: 2,
  display: 'flex',
  justifyContent: 'center',
};
